import { EmployerAgreementSourcesService_employerAgreementSourcesSimulateServicePostEntity } from '@festina/life-general-types/life/hooks/EmployerAgreementSourcesService_employerAgreementSourcesSimulateServicePostEntity'

export const useFetchEmployerAgreementVersionSimulation =
  EmployerAgreementSourcesService_employerAgreementSourcesSimulateServicePostEntity.useSuspenseQuery
